import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteVendorCreationPopupContent.AddressLinesInformation',
    {
        addressesSection: 'Addresses',
        defaultShipping: 'Default shipping',
        defaultBilling: 'Default billing',
        label: 'Label',
        country: 'Country',
        attention: 'Attention',
        addressee: 'Addressee',
        primaryAddress: 'Address 1',
        secondaryAddress: 'Address 2',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        phone: 'Phone',
        addLineButtonText: 'Add line',
        inputPlaceholder: 'Enter value',
        selectPlaceholder: 'Select value',
        cloneLine: 'Clone a line',
        removeLine: 'Remove a line',
    }
);
